/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_No_Jobs_MessageInputs */

const en_company_jobs_no_jobs_message = /** @type {(inputs: Company_Jobs_No_Jobs_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have not created any job postings yet.`)
};

const de_company_jobs_no_jobs_message = /** @type {(inputs: Company_Jobs_No_Jobs_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben noch keine Stellenangebote erstellt.`)
};

/**
* | output |
* | --- |
* | "You have not created any job postings yet." |
*
* @param {Company_Jobs_No_Jobs_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_no_jobs_message = /** @type {((inputs?: Company_Jobs_No_Jobs_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_No_Jobs_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_no_jobs_message(inputs)
	return en_company_jobs_no_jobs_message(inputs)
});